import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../Config/firebase';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  const signUp = async () => {
    if (!email || !password) {
      alert('Invalid value. Please try again.');
      return;
    }else{
      localStorage.setItem('email', email);
      localStorage.setItem('password', password);
      navigate('/Home');
    }

    try {
      await createUserWithEmailAndPassword(auth, email, password);
      
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleSignInClick = () => {
    const storedEmail = localStorage.getItem('email');
    const storedPassword = localStorage.getItem('password');

    if (storedEmail && storedPassword) {
      navigate('/Home');
    } else {
      alert('Please sign up first.');
    }
  };

  return (
    <div className="login-page">
      <h1>
        Connect<span>BlueLoop</span>
      </h1>
      <form className="login-form" name="form">
        <input
          type="email"
          placeholder="Email..."
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password..."
          onChange={(e) => setPassword(e.target.value)}
        />

        <button onClick={signUp}>Sign Up</button>
        <a href="#" onClick={handleSignInClick}>
          Already have an Account?
        </a>
      </form>
    </div>
  );
};

export default Login;
